import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart'
import Service from './service';

class ChartView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false
    }

    componentDidMount () {
        Service.event.onFetchRevenueStatsBySubject.add((chartData) => {
            this.setState({
                histogramChartCategoriesList: chartData.categoryList,
                histogramChartSeriesDataList1: chartData.seriesDataList1,
                renderChart : true
            });
        });

        Service.fetchRevenueStatsBySubject(30);
    }

    componentWillUnmount() {

    }

    render() {

        const options = {
            chart: {
                type: 'column'
            },
            title: {
                text: 'Revenue by Subject for the last 30 days (top 20)'
            },
            xAxis: {
                categories: this.state.histogramChartCategoriesList
            },
            yAxis: {
                title: {
                    text: 'Revenue by subject'
                }
            },
            tooltip: {
                pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y:.2f}</b><br/>',
                shared: true
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                }, series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '${point.y:.2f}',
                    }
                }
            },
            series: [{
                name: 'Revenue by Shipment',
                data: this.state.histogramChartSeriesDataList1
            }]
        };

        return (
            <div className="graph-width">
                { this.state.renderChart ? <CustomChart options={options}/> : '' }
            </div>
        );
    }
}

export default ChartView;
